import { Link } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore';

/**
 * Generic 404 Not Found page.
 * Used for non-discoverability of admin routes and actual 404s.
 * Guest users are redirected to the home page, authenticated users to dashboard.
 */
export default function NotFoundPage() {
  const isAuthenticated = useAuthStore((state: { isAuthenticated: boolean }) => state.isAuthenticated);
  
  // Determine appropriate back link based on auth state
  const backLink = isAuthenticated ? '/dashboard' : '/';
  const backText = isAuthenticated ? 'Back to Dashboard' : 'Back to Home';
  return (
    <div className="min-h-screen bg-slate-900 flex items-center justify-center px-4">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-slate-600 mb-4">404</h1>
        <h2 className="text-2xl font-semibold text-white mb-2">Page Not Found</h2>
        <p className="text-slate-400 mb-8">
          The page you're looking for doesn't exist or you don't have access to it.
        </p>
        <Link
          to={backLink}
          className="inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
        >
          <svg className="w-5 h-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
          </svg>
          {backText}
        </Link>
      </div>
    </div>
  );
}
